import type { DevicesLocales } from '@/types/lang/locales'
import { devicesEn as rfcDevicesEn } from '@rfc/rfc-components-library/locales'

export const devicesEn: DevicesLocales = {
    ...rfcDevicesEn,
    actions: {
        ...rfcDevicesEn.actions,

        reassignCheckpoint: 'Assign to a checkpoint',
        attachDeviceToOrganization: 'Attach to a client',
        detachDeviceToOrganization: 'Detach from a client',
        changeDeviceType: 'Change device type'
    },
    checkpoints: {
        detectionsCount: 'Reads count :'
    },

    cardContent: {
        checkpointAssociatedTitle: 'Checkpoint associated',
        eventAssociatedTitle: 'Event associated',
        noEventAssociated: 'No associated event',
        noCheckpointAssociated: 'No associated checkpoint'
    },
    configuration: {
        ...rfcDevicesEn.configuration,
        errors: {
            rangeError: 'Value should be between {min} and {max}',
            excludedError: "Value can't be {excluded}"
        },
        apiKey: 'uRTime API Key'
    },
    detail: {
        ...rfcDevicesEn.detail,
        detections: {
            ...rfcDevicesEn.detail.detections,
            table: {
                ...rfcDevicesEn.detail.detections.table,
                bib: 'Bib',
                checkpoint: 'Checkpoint',
                event: 'Event',
                event_filter: 'Event filter',
                timer_filter: 'Timer filter'
            }
        }
    },
    filters: {
        ...rfcDevicesEn.filters,
        checkpoint: 'Checkpoint',
        event: 'Event'
    },
    latestDetections: 'Reads',
    model: {
        ...rfcDevicesEn.model,
        checkpointName: 'Checkpoint associated',
        eventName: 'Event associated'
    },
    rental: {
        ...rfcDevicesEn.rental,
        infoTitle: 'Rented',
        nextRentals: 'Next rentals',
        unavailabilities: 'Unavailabilities',

        updateCurrentRentalAction: 'Update rental',
        updateCurrentRentalTitle: 'Update current rental',
        updateCurrentRentalDescription:
            'Do you really want to update the current rental ? This action cannot be undone.',
        updateRentalApiSuccess: 'Rental updated !',

        endCurrentRentalAction: 'End rental',
        endCurrentRentalTitle: 'End current rental',
        endCurrentRentalDescription:
            "Do you really want to end the current rental ? This action will remove the tenant's access to the device.",
        endRentalApiSuccess: 'Rental ended !'
    },
    table: {
        ...rfcDevicesEn.table,
        currentEventTitle: 'Event associated'
    },
    title: {
        checkpointTitle: 'Checkpoint',
        eventTitle: 'Event',
        checkpointAssociatedTitle: 'Checkpoint associated',
        currentEventTitle: 'Event associated',
        noEventAssociated: 'No associated event'
    }
}
